import {
  observable,
  transaction,
  map,
  computed,
  reaction,
  runInAction,
  action,
  toJS
} from 'mobx';
import QueryApi from '../api/QueryApi';
import ColumnSet from './ColumnSet';
import tools from '../../../../utils/tools';

const serializableWhere = (wherePara) => {
  let para = {};
  if (wherePara && typeof wherePara === 'object') {
    para = {};
    for (let p in wherePara) {
      if (wherePara.hasOwnProperty(p)) {
        para[p] = escape(wherePara[p]);
      }
    }
  }
  return para;
}

const formatsql = (refWhere) => { 
  if(refWhere.indexOf('DateTime')>-1){
    return ''; 
  }
  if (refWhere && refWhere.indexOf(':') !== -1) {
    if (refWhere.indexOf('Key@') == 0) {
      refWhere = 'Key@' + refWhere.split(':')[1]; //使用refWhere参数，需要去掉':'之前的sql。
    } else {
      refWhere = refWhere.split(':')[1]; //使用refWhere参数，需要去掉':'之前的sql。
    }
  }
  return refWhere;
}

class RefModel {
  @observable searchItemCtrlId = null;
  @observable refObject = null;
  @observable refDataSource = null;
  @observable columnSet = null;
  @observable data = [];
  @observable pageIndex = 0;
  @observable sortby = null;
  @observable strWhere = null;
  @observable sqlText = null;
  @observable whereParams = null;
  @observable searchValue = null;
  @observable totalPageNum = 1;
  @observable refTitle = null;
  @observable dropDownStyle = null;

  @observable enumItems = [];
  @observable enumName = null;

  @observable selecteds = [];

  @observable loaded = false;
  @observable error = null;

  @observable multiSelect = false;

  @observable filter = false;
  @observable chose = {};
  @observable reportSolutionId = null;
  @observable reportName = null;
  @observable taskSessionId = null;
  @observable localSearch = false;
  @observable refShowField = null;
  @observable type = '';


  constructor(planObj) {
    this.externalParam = planObj.externalParam ? planObj.externalParam : null;
  }

  @computed get displayData() {
    console.log('columuset', this.columnSet)
    if (this.filter) {
      return this.data.map((it, i) => ({
        name: it.Name,
        value: it

      }));
    }
    if (!this.columnSet) {
      return [];
    }
    // fix PDEVELOPER-40415 【offline+SaaS包】集成4：移动报表，手机端销售报表查询条件适用bom选择值不正确
    return this.data.map((it, i) => {
      let names = this.columnSet.displayColumn ? this.columnSet.displayColumn.map(item => {
        if (!tools.isNull(it[item.field])) {
          return it[item.field];
        }
      }) : [];
      names = names.length == 1 && names[0] == undefined ? [] : names;
      return {
        name: names && names.length > 0 ? names : (it.Name || it.Code || it.ID || it.Value),
        value: it
      }
    });
  }

  @computed get hasMore() {
    if (this.enumItems) {
      return false;
    }
    if (this.pageIndex >= this.totalPageNum) {
      return false;
    }
    return true;
  }

  @action select(value) {
    const index = this.indexOf(this.selecteds, value)
    if (index > -1) {
      let selectObj = toJS(this.selecteds);
      selectObj.splice(index, 1);
      this.selecteds = selectObj;
    } else {
      this.selecteds = this.selecteds.concat([value]);
    }
  }

  @action async load({
    enumItems,
    enumName,
    searchItemCtrlId,
    refDataSource,
    dtoName,
    multiSelect,
    selecteds = [],
    refSortField,
    sortby,
    dropDownStyle,
    sqlText,
    name,
    whereParams,
    searchValue,
    dropDownWhere,
    initDropDownWhere,
    refWhere,
    initRefWhere,
    filter = false,
    chose = {},
    reportSolutionId,
    taskSessionId,
    reportName,
    localSearch = false,
    refShowField,
    type,
  }) {
    this.loaded = false;
    this.multiSelect = multiSelect;
    this.filter = filter;
    this.chose = chose;
    this.localSearch = localSearch;
    this.selecteds.length = 0;
    this.selecteds = this.selecteds.concat(selecteds);
    this.reportSolutionId = reportSolutionId;
    this.reportName = reportName;
    this.taskSessionId = taskSessionId;
    this.searchValue = searchValue;
    this.refShowField = refShowField;

    this.pageIndex = 0;
    // 已经有下拉枚举就用加载数据了
    // if (!this.enumItems) {
    this.totalPageNum = 1; // 这里不要设置0
    this.data.length = 0;
    if (filter) {
      this.refTitle = '筛选项';
      await this.loadFilter();
    } else {
      try {
        this.enumItems = enumItems;
        this.enumName = enumName.toLowerCase().startsWith('freeitem') ? `enum${enumName.toLowerCase()}` : enumName; //自由项下拉需要完整的enumname
        this.refDataSource = refDataSource;
        this.refObject = dtoName;
        this.searchItemCtrlId = searchItemCtrlId;
        this.sortby = refSortField || sortby;
        //控件类型为multireftextbox时 取dropDownWhere为refwhere
        dropDownWhere = this.getdropDownWhere(type, dropDownWhere, refWhere);
        this.strWhere = dropDownWhere || initDropDownWhere;
        this.refWhere = refWhere || initRefWhere;
        this.sqlText = sqlText;
        this.columnSet = {};
        this.whereParams = whereParams;
        this.dropDownStyle = dropDownStyle;
        this.type = type;
        // if ((this.refObject&&!this.refDataSource) || (!this.refObject && this.enumName) || refDataSource === 'Eap_EnumItemDTO' || (enumItems && enumItems.length > 0)) {
        if (((this.refObject && !this.refDataSource) || (!this.refObject && this.enumName) || (enumItems && enumItems.length > 0)) && refDataSource === 'Eap_EnumItemDTO') {
          if (refWhere || initRefWhere) {
            this.strWhere = refWhere || initRefWhere;
          }
          this.refTitle = name;
          this.columnSet = ColumnSet.Enums(this);
        } else if (this.refDataSource) {
          const info = await QueryApi.getRefBase(refDataSource);
          runInAction(() => {
            this.refTitle = (info.refTitle || name).replace('参照', '');
          })

          const solumnSet = await QueryApi.getRefColumnSets(refDataSource, dtoName);
          runInAction(() => {
            this.columnSet = ColumnSet.fromJS(this, solumnSet);
          })
        } else {
          this.refTitle = name;
        }

        await this.loadNext();
        // }
      } catch (err) {
        //this.error = err.message;
      }
    }
    runInAction(() => {
      this.loaded = true;
    });
  }

  //控件类型为multireftextbox时 取dropDownWhere为refwhere
  getdropDownWhere(n, a, r) {
    if ("multireftextbox" === n.toLowerCase() && !a && r) {
      var o = r.split(":");
      a = o.length > 1 && o[1].trim() ? o[1] : r
    }
    return a
  }

  @action async loadNext(searchValue) {
    console.log('searchValue:', searchValue);
    if (this.searchValue !== searchValue) {
      this.pageIndex = 0;
    }
    this.searchValue = searchValue;
    if (this.localSearch) {
      return;
    }
    // if (!searchValue && this.pageIndex >= this.totalPageNum) {
    //   return;
    // }
    try {
      let data;
      if (((!this.refObject && this.enumName) || this.refDataSource === 'Eap_EnumItemDTO' || (this.enumItems && this.enumItems.length > 0)) && this.type && this.type.toLowerCase() != 'textcombobox') {
        if (this.enumItems && this.enumItems.length > 0) {
          // todo
        }
        data = await QueryApi.getEnumItems({
          "enumName": this.enumName,
          "strDataSourceKey": (this.refDataSource === 'Eap_EnumItemDTO' && !this.refWhere) ? '' : this.refDataSource,
          "where": escape(formatsql(this.strWhere || '')),
          "moduleName": "",
          "whereParams": serializableWhere(this.whereParams),
          "top": 50
        })
        runInAction(() => {
          if (!!searchValue) {
            data = data.filter(item => item.Name.indexOf(searchValue) > -1); // 这是用Name做过滤，需要再确认一下
          }
          this.totalPageNum = 1;
          this.data = data;
          this.pageIndex = 1;
        })

      } else if (this.strWhere && this.type && this.type.toLowerCase() == 'textcombobox') {
        data = await QueryApi.getSqlTable({
          "dataSourceKey": this.refDataSource,
          "sqlText": this.sqlText ? this.sqlText : this.strWhere,
          "whereParams": serializableWhere(this.whereParams),
        });
        runInAction(() => {
          var { compactDataTable } = data;
          this.totalPageNum = 1;
          if (!!searchValue) {
            // 这是用Name code Value做过滤，需要再确认一下
            compactDataTable = compactDataTable.filter(item => (item.Name && item.Name.indexOf(searchValue) > -1) || (item.Code && item.Code.indexOf(searchValue) > -1) || (item.Value && item.Value.indexOf(searchValue) > -1));
          }
          this.data = compactDataTable
          this.pageIndex = 1;
        });

      } else if (this.sqlText) {
        data = await QueryApi.getSqlTable({
          "dataSourceKey": this.refDataSource,
          "sqlText": this.sqlText,
          "whereParams": serializableWhere(this.whereParams),
        });
        runInAction(() => {
          this.totalPageNum = 1;
          this.data = data;
          this.pageIndex = 1;
        })

      } else {
        let tempWhere = escape(formatsql(this.strWhere || ''));
        if(this.externalParam && this.externalParam.ExternalRefParam){
          this.externalParam.ExternalRefParam.forEach(item=>{
            if(item.Name == tempWhere){
              tempWhere += item.Value;
            }
          })
        }
        data = await QueryApi.getRefData(this.dropDownStyle, {
          "searchItemCtrlId": this.searchItemCtrlId,
          "strDataSourceKey": this.refDataSource,
          "refObj": this.refObject,
          "sortby": this.sortby,
          "strWhere": tempWhere,
          "whereParams": serializableWhere(this.whereParams),
          "codename": searchValue || this.searchValue || '',
          "currentPage": this.pageIndex,
          "pageSize": this.dropDownStyle === 'DropDownList' ? 50 : 20,
          "dropDownGridMatchMode": "4",
          "menuCode": ""
        });
        runInAction(() => {
          const {
            compactDataTable,
            pagePara
          } = data;
          this.totalPageNum = pagePara.TotalPageNum;
          if (pagePara.CurrentPageNum === 0) {
            this.data = compactDataTable;
          } else {
            this.data = this.data.concat(compactDataTable);
          }
          this.pageIndex = this.pageIndex + 1;
        });

      }
      runInAction(() => {
        this.loaded = true;
      })
    } catch (err) {
      this.error = err.message;
    }
  }

  //获取二次筛选项
  @action async loadFilter() {
    //组装参数
    let data = await QueryApi.getReportColumnFilterItems({
      "ColumnName": this.chose.name,
      "FilterColumn": [],
      "ReportName": this.reportName,
      "ReportSolutionID": this.reportSolutionId,
      "TaskSessionId": this.taskSessionId,
    });

    runInAction(() => {
      console.log('data=====' + data);
      this.data = data.map((name) => {
        if (this.chose && this.chose.type === '1') {
          name = tools.formatDisplay(name, this.chose.format);
        }
        let obj = { "Name": name, 'value': name };
        return obj;
      })

      console.log("this.data=====" + this.data);
    });
  }

  @action clearSelect() {
    this.selecteds = [];
  }

  @action clearError() {
    this.error = null;
  }


  _hasProp = (obj, key) => {
    return !!Object.keys(obj).find(it => it.toLowerCase() === key) || (key === 'text' ? !!Object.keys(obj).find(it => it.toLowerCase() === 'name') : false);
  }

  _getProp = (obj, key) => {
    const k = Object.keys(obj).find(it => it.toLowerCase() === key || (key === 'text' ? it.toLowerCase() === 'name' : false));
    if (k) {
      return (obj[k] || '').toString();
    } else {
      return null;
    }
  }

  @action indexOf = (items, it) => {
    if (items.indexOf(it) > -1) {
      return items.indexOf(it);
    } else {
      // 模糊匹配
      // items的所有字段都包含
      const t = items.find((sit, i) => {
        const keys = Object.keys(sit).map(it => it.toLowerCase());
        const upKeys = Object.keys(sit);
        let exists = true;
        // 如果有id就比较id即可
        if (this._hasProp(sit, 'id') && this._hasProp(it, 'id') && this._getProp(sit, 'id') !== this._getProp(it, 'id')) {
          exists = false;
        } else {
          if (!keys.find(k => this._hasProp(it, k)) && it.Value) {
            if (this._getProp(sit, 'text') !== this._getProp(it, 'value')) {
              exists = false;
            }
          } else {
            keys.forEach(k => {
              if (this._hasProp(sit, k) && this._hasProp(it, k) && this._getProp(sit, k) !== this._getProp(it, k)) {
                exists = false;
              }
            });
            let length = keys.filter(k => {
              return this._hasProp(it, k);
            })
            if (length.length == 0 && it.ID != sit[upKeys[1]]) {
              exists = false;
            }
          }
        }
        return exists;
      });
      return t ? items.indexOf(t) : -1;
    }
    return -1;
  }

}
export default RefModel;
